export default "__VITE_ASSET__BAQPtQu___"